import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';
const firebaseRef = firebase.database();

export async function setDepositCheck(leadId, depositIndex, file) {
	const fileName = depositIndex + '_' + dayjs(new Date());

	let storage = await firebase
		.storage()
		.ref(
			PROJECT_CODE.projectCode +
				'/kavtek_checks/' +
				leadId +
				'/' +
				fileName
		);
	await storage.put(file);
	await storage.getDownloadURL().then((url) => {
		firebaseRef
			.ref(
				'/kavtek_agreements/' +
					PROJECT_CODE.projectCode +
					'/' +
					leadId +
					'/depositSchedule/' +
					depositIndex
			)
			.update({
				img: url,
			});
	});
}
